import { render, staticRenderFns } from "./AccommodationServiceItem.vue?vue&type=template&id=7341caad&"
import script from "./AccommodationServiceItem.vue?vue&type=script&lang=js&"
export * from "./AccommodationServiceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports